import * as React from 'react';

import GoogleLogoSvg from 'shells/logos/google-g.svg';
import O365LogoSvg from 'shells/logos/office-365.svg';

import type {CalendarSync} from 'nutshell-graphql-types';

import {InitialButton} from '../integrations/initial-button';
import type {AuthSuccessResult} from '../integrations/initial-button';

import {GOOGLE_WINDOW_FEATURES, OFFICE365_WINDOW_FEATURES} from './consts';
import {
    useSetGoogleCalendarSyncIsEnabled,
    useSetGoogleConflictCalendarSyncIsEnabled,
    useSetOffice365CalendarSyncIsEnabled,
    useSetOffice365ConflictCalendarSyncIsEnabled,
} from './graphql/hooks';

const o365Logo = <O365LogoSvg width={24} />;
const googleLogo = <GoogleLogoSvg width={24} />;

type Props = {
    isForConflictCalendar?: boolean;
    calendarSync: CalendarSync | null | undefined;
    refetchSyncStatus?: () => Promise<any>;
    errorMessages: Array<string>;
    setErrorMessages: (arg1: Array<string>) => void;
    onAuthSuccess?: (arg1?: AuthSuccessResult | null | undefined) => void;
    onAuthStart?: () => void;
    isFullWidth?: boolean;
    forceReauth?: boolean;
};

export function CalendarConnectButtons(props: Props) {
    const {enableGoogleConflictCalendar} = useSetGoogleConflictCalendarSyncIsEnabled();
    const {enableO365ConflictCalendar} = useSetOffice365ConflictCalendarSyncIsEnabled();
    const {enableGoogle} = useSetGoogleCalendarSyncIsEnabled();
    const {enableO365} = useSetOffice365CalendarSyncIsEnabled();

    return (
        <>
            <InitialButton
                initialText='Connect to my Google Calendar'
                authCheckUrl='/google/has-auth'
                windowFeatures={GOOGLE_WINDOW_FEATURES}
                logo={googleLogo}
                enable={props.isForConflictCalendar ? enableGoogleConflictCalendar : enableGoogle}
                onAuthStart={() => {
                    props.onAuthStart?.();
                    props.setErrorMessages([]);
                }}
                onAuthSuccess={(result) => {
                    props.onAuthSuccess?.(result);

                    return props.refetchSyncStatus ? props.refetchSyncStatus() : Promise.resolve();
                }}
                onAuthError={(errMsgs) =>
                    props.setErrorMessages(errMsgs.concat(props.errorMessages))
                }
                disabled={props.calendarSync !== null}
                isFullWidth={props.isFullWidth}
                forceReauth={props.forceReauth}
            />
            <InitialButton
                initialText='Connect to my Office 365 Calendar'
                authCheckUrl='/office365/has-auth'
                windowFeatures={OFFICE365_WINDOW_FEATURES}
                logo={o365Logo}
                enable={props.isForConflictCalendar ? enableO365ConflictCalendar : enableO365}
                onAuthStart={() => {
                    props.onAuthStart?.();
                    props.setErrorMessages([]);
                }}
                onAuthSuccess={(result) => {
                    props.onAuthSuccess?.(result);

                    return props.refetchSyncStatus ? props.refetchSyncStatus() : Promise.resolve();
                }}
                onAuthError={(errMsgs) =>
                    props.setErrorMessages(errMsgs.concat(props.errorMessages))
                }
                disabled={props.calendarSync !== null}
                isFullWidth={props.isFullWidth}
            />
        </>
    );
}
